import React from 'react';
import {
  Button,
  Input, InputNumber, Select, Spin, Tabs,
} from 'antd';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Box, ShowIf, Text } from '../../../shared/components';
import TwoColumnsFlexLayout from '../../../shared/components/layout/TwoColumnsFlex.layout';
import NumberFormat from '../../../shared/components/dataDisplay/NumberFormat';
import { gridSetFilterAction, gridRequestAction, gridInit } from '../../../../state/actions/creators/grideable.actioncreator';
import { handleSagaStatus, obtenerEstadoRequestDesdeSaga } from '../../../../helpers/sagaStatus.helper';
import { calcularBonificacionEstatica, calcularBonificacionVariable } from '../../../../helpers/modules/bonificaciones.helper';
import SelectBonificacionesEstaticas from './SelectorBonificacionesEstaticas.descuentos.dataentry';
import { detalleCreacionType, encargoCreacionType } from '../../types/encargo.creacion.types';

const { TabPane } = Tabs;
const { Option } = Select;
const ENDPOINT = 'BONIFICACIONES_DESCUENTO_TAB';

class DescuentosTabs extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      seleccion: {
        precioAlza: null,
        descuento: {
          cantidad: null,
          tipo: null,
        },
        bonificacionVariableId: null,
        bonificacionesEstaticasSeleccionadas: [],
      },
      precioMinimo: 0,
      precioOriginal: null,
      bonificacionesVariables: [],
      bonificacionesEstaticas: [],
      maxNumBonificacionesEstaticas: 3,
      activeTab: '1',
      tieneModificaciones: false,
    };
  }

  initState() {
    const { detalle } = this.props;
    const { articulo, descuento: { bonificacionVariable, bonificacionesEstaticas } } = detalle;
    const { pvp: pvpOriginal } = articulo;
    const {
      precioAlza, cantidad, tipo, id: bonificacionVariableId,
    } = bonificacionVariable;
    const noPuedeAplicarBonificacionesPrecioAlza = bonificacionesEstaticas.find(({ tipo }) => tipo === 2) !== undefined;
    const hayBonificacionesEstaticasAplicadas = bonificacionesEstaticas.length > 0;
    const bonificacionesVariablesDesactivadas = noPuedeAplicarBonificacionesPrecioAlza && hayBonificacionesEstaticasAplicadas;
    const precio = (precioAlza === null) ? pvpOriginal : precioAlza;
    const tieneModificaciones = hayBonificacionesEstaticasAplicadas || precioAlza > 0 || bonificacionVariableId != null;
    this.setState({
      precioOriginal: pvpOriginal,
      precioMinimo: pvpOriginal,
      seleccion: {
        bonificacionesEstaticasSeleccionadas: bonificacionesEstaticas,
        bonificacionVariableId,
        precioAlza: precio,
        descuento: {
          cantidad,
          tipo,
        },
      },
      activeTab: bonificacionesVariablesDesactivadas ? '2' : '1',
      tieneModificaciones,
    });
  }

  borrarTodo() {
    const { onBorrarTodo } = this.props;
    onBorrarTodo();
    this.cancelar();
  }

  cancelar() {
    const { onClose } = this.props;
    this.initState();
    onClose();
  }

  aplicar() {
    const { onAplicar } = this.props;
    const {
      seleccion: {
        descuento: { tipo, cantidad }, precioAlza, bonificacionVariableId, bonificacionesEstaticasSeleccionadas,
      },
    } = this.state;
    onAplicar({
      bonificacionVariable: {
        id: bonificacionVariableId,
        precioAlza,
        tipo,
        cantidad,
      },
      bonificacionesEstaticas: bonificacionesEstaticasSeleccionadas,
    });
  }

  obtenerBonificacionesDesdeServidor() {
    const {
      gridSetFilterAction, gridRequestAction, gridInit, detalle, encargo, tiendaId,
    } = this.props;
    const { cabecera: { cliente: { codigoGrupoCliente } } } = encargo;
    const { cdgtipo } = detalle;
    gridInit({ endpoint: ENDPOINT });
    gridSetFilterAction({
      endpoint: ENDPOINT,
      filters: {
        id: { valor: 0, operador: 'gt' },
        inactivo: { valor: 'NO' },
        'detalles.tipo_articulo_id': { valor: [cdgtipo, -1], operador: 'in' },
        'detalles.grupo_cliente_id': { valor: [codigoGrupoCliente, -1], operador: 'in' },
        pack_cerrado: { valor: 0 },
        es_crm: { valor: 0 },
        es_de_un_pack: { valor: 'NO' },
        es_compromiso: { valor: 'NO' },
        ambito: { valor: [0, 3, 4], operador: 'in' },
        sucursales: { valor: ['-1', `.${tiendaId};`], operador: 'like' },
      },
    });
    gridRequestAction({
      url: 'api/bonificaciones/buscar',
      endpoint: ENDPOINT,
      limite: 50,
    });
  }

  componentDidMount() {
    this.initState();
    this.obtenerBonificacionesDesdeServidor();
  }

  componentDidUpdate(prevProps) {
    const { grideableBonificaciones: previousRequestState } = prevProps;
    const { grideableBonificaciones, detalle: { cdgtipo } } = this.props;
    handleSagaStatus({
      estadoPeticion: grideableBonificaciones,
      previousEstadoPeticion: previousRequestState,
      onWasRunningAndHasSucceded: () => {
        const { datos } = grideableBonificaciones;
        if (datos) {
          const bonificacionesVariables = datos.filter(bonificacion => bonificacion.tipo == 4).map((bonificacion) => {
            const { detalles } = bonificacion;
            let detalle = null;
            if (detalles.length > 0) {
              detalle = detalles.find(detalle => detalle.tipo_articulo_id == cdgtipo);
              if (detalle === undefined || detalle === null) {
                detalle = detalles[0];
              }
            }
            return {
              ...bonificacion,
              detalle,
            };
          });
          const bonificacionesEstaticas = datos.filter(bonificacion => bonificacion.tipo != 4).map((bonificacion) => {
            const { detalles } = bonificacion;
            let detalle = null;
            if (detalles.length > 0) {
              detalle = detalles.find(detalle => detalle.tipo_articulo_id == cdgtipo);
              if (detalle === undefined || detalle === null) {
                detalle = detalles[0];
              }
            }
            return {
              ...bonificacion,
              detalle,
            };
          });
          this.setState({
            bonificacionesVariables,
            bonificacionesEstaticas,
          });
        }
      },
    });
  }

  aplicarBonificacionEstatica({ posicion, idBonificacion }) {
    const { bonificacionesEstaticas, seleccion } = this.state;
    const { bonificacionesEstaticasSeleccionadas } = seleccion;
    if (idBonificacion === undefined) {
      this.setState({
        seleccion: {
          ...seleccion,
          bonificacionesEstaticasSeleccionadas: bonificacionesEstaticasSeleccionadas.slice(0, posicion),
        },
      });
    } else {
      const bonificacionesCopia = [...bonificacionesEstaticasSeleccionadas];
      const informacionCompletaBonificacion = bonificacionesEstaticas.find(bonificacion => bonificacion.id === idBonificacion);
      const {
        id, tipo, tipo_cadena: tipoCadena, detalle,
      } = informacionCompletaBonificacion;
      if (detalle) {
        const { valor } = detalle;
        bonificacionesCopia[posicion] = {
          id,
          tipo,
          tipoCadena,
          valor: parseFloat(valor),
        };
        this.setState({
          seleccion: {
            ...seleccion,
            bonificacionesEstaticasSeleccionadas: bonificacionesCopia,
          },
        });
      }
    }
  }

  render() {
    const {
      precioOriginal, precioMinimo, bonificacionesVariables, bonificacionesEstaticas,
      maxNumBonificacionesEstaticas, activeTab, tieneModificaciones,
      seleccion,
    } = this.state;
    const {
      precioAlza, descuento, bonificacionVariableId, bonificacionesEstaticasSeleccionadas,
    } = seleccion;
    const { grideableBonificaciones: { running: peticionEnCurso } } = this.props;
    const { cantidad: cantidadDescuento, tipo: tipoDescuento } = descuento;

    const precioConBonificacionVariable = calcularBonificacionVariable({ precioOriginal: precioAlza, bonificacion: descuento });
    const precioConBonificacionesEstaticas = calcularBonificacionEstatica({ precioOriginal: precioAlza, bonificaciones: bonificacionesEstaticasSeleccionadas });
    const OptionsConceptoDescuento = bonificacionesVariables.map(({ id, descripcion }) => <Option key={id} value={id}>{descripcion}</Option>);
    const noPuedeAplicarBonificacionesPrecioAlza = bonificacionesEstaticasSeleccionadas.find(({ tipo }) => tipo === 2) !== undefined;
    const hayBonificacionesEstaticasAplicadas = bonificacionesEstaticasSeleccionadas.length > 0;
    const bonificacionesVariablesDesactivadas = noPuedeAplicarBonificacionesPrecioAlza && hayBonificacionesEstaticasAplicadas;
    const hayCantidadDeBonificacionVariableAplicada = cantidadDescuento !== null && cantidadDescuento !== undefined;
    const hayBonificacionPrecioAlzaAplicada = precioAlza > precioOriginal;
    const sePuedeGuardar = (hayCantidadDeBonificacionVariableAplicada && bonificacionVariableId != undefined || hayBonificacionPrecioAlzaAplicada) || hayBonificacionesEstaticasAplicadas;

    const InputPrecioAlza = (
      <InputNumber
        disabled={noPuedeAplicarBonificacionesPrecioAlza}
        value={precioAlza}
        onChange={(precioAlza) => {
          this.setState({
            seleccion: {
              ...seleccion,
              precioAlza,
            },
          });
        }}
        min={precioMinimo}
        style={{ width: '100%' }}
      />
    );

    const InputCantidadDescuento = (
      <Input
        disabled={hayBonificacionesEstaticasAplicadas}
        min={0}
        type="number"
        value={cantidadDescuento}
        onChange={(event) => {
          const { value } = event.target;
          let cantidad = null;
          if (value) {
            cantidad = parseFloat(value);
          }
          if(cantidad <= 0 ) return;
          if (tipoDescuento === 'porcentaje' && cantidad > 100) return;
          if (tipoDescuento === 'importe' && cantidad > precioAlza) return;
          this.setState({
            seleccion: {
              ...seleccion,
              descuento: { ...descuento, cantidad },
            },
          });
        }}
        addonAfter={(
          <Select
            disabled={hayBonificacionesEstaticasAplicadas}
            onChange={(tipo) => {
              const nuevaSeleccion = {
                ...seleccion,
                descuento: {
                  ...descuento,
                  tipo,
                },
              };
              if (tipo === 'porcentaje' && cantidadDescuento > 100) {
                nuevaSeleccion.descuento.cantidad = 100;
              }
              this.setState({ seleccion: nuevaSeleccion });
            }}
            value={tipoDescuento}
            style={{ width: '48px' }}
          >
            <Option value="porcentaje">%</Option>
            <Option value="importe">€</Option>
          </Select>
        )}
      />
    );

    return (
      <Spin
        spinning={peticionEnCurso}
      >
        <Box>
          <Tabs activeKey={activeTab} onChange={activeTab => this.setState({ activeTab })}>
            <TabPane tab="Descuento" key="1" disabled={bonificacionesVariablesDesactivadas}>
              <Box px="16">
                <TwoColumnsFlexLayout
                  leftContent={(
                    <Box>
                      <Text mb="8" display="block" translationId="encargos.pvp" />
                      { InputPrecioAlza }
                    </Box>
                  )}
                  rightColumnStyle={{ marginLeft: '16px' }}
                  rightContent={(
                    <Box>
                      <Text mb="8" display="block" translationId="encargos.descuento" />
                      { InputCantidadDescuento }
                    </Box>
                  )}
                />
                <Box mt="8">
                  <Text mb="8" display="block" translationId="encargos.concepto_descuento" />
                  <Select
                    disabled={(hayBonificacionesEstaticasAplicadas && noPuedeAplicarBonificacionesPrecioAlza) || !hayCantidadDeBonificacionVariableAplicada}
                    style={{ width: '100%' }}
                    placeholder="Seleccione concepto"
                    onChange={value => this.setState({
                      seleccion: {
                        ...seleccion,
                        bonificacionVariableId: value,
                      },
                    })}
                    value={bonificacionVariableId}
                    allowClear
                  >
                    { OptionsConceptoDescuento }
                  </Select>
                </Box>
              </Box>
            </TabPane>
            <TabPane tab="Bonificaciones" key="2" disabled={hayCantidadDeBonificacionVariableAplicada}>
              <Box px="16">
                <SelectBonificacionesEstaticas
                  hayBonificacionPrecioAlzaAplicada={hayBonificacionPrecioAlzaAplicada}
                  disabled={hayCantidadDeBonificacionVariableAplicada}
                  bonificacionesEstaticas={bonificacionesEstaticas}
                  bonificacionesEstaticasSeleccionadas={bonificacionesEstaticasSeleccionadas}
                  maxNumBonificacionesEstaticas={maxNumBonificacionesEstaticas}
                  onChange={({ posicion, idBonificacion }) => this.aplicarBonificacionEstatica({ posicion, idBonificacion })}
                />
              </Box>
            </TabPane>
          </Tabs>
          <Box my="16">
            <ShowIf condition={hayBonificacionPrecioAlzaAplicada}>
              <TwoColumnsFlexLayout
                px="16"
                mb="8"
                leftContent={
                  <Text color="gray" fontSize="12">PVP al alza:</Text>
                }
                rightContent={(
                  <NumberFormat color="gray" style={{ float: 'right' }} fontSize="12" number={precioAlza} />
                )}
              />
            </ShowIf>
            <ShowIf condition={cantidadDescuento > 0}>
              <TwoColumnsFlexLayout
                px="16"
                mb="8"
                leftContent={
                  <Text color="gray" fontSize="12">PVP con descuento:</Text>
                }
                rightContent={(
                  <NumberFormat color="gray" style={{ float: 'right' }} fontSize="12" number={precioConBonificacionVariable} />
                )}
              />
            </ShowIf>
            <ShowIf condition={precioConBonificacionesEstaticas !== precioAlza}>
              <TwoColumnsFlexLayout
                px="16"
                mb="8"
                leftContent={
                  <Text color="gray" fontSize="12">PVP con bonificaciones:</Text>
                }
                rightContent={(
                  <NumberFormat
                    color="gray"
                    style={{ float: 'right' }}
                    fontSize="12"
                    number={precioConBonificacionesEstaticas}
                  />
                )}
              />
            </ShowIf>
            <TwoColumnsFlexLayout
              leftContent={(
                <Box px="16">
                  <ShowIf condition={tieneModificaciones}>
                    <Button
                      disabled={!sePuedeGuardar}
                      style={{ float: 'left', padding: 0 }}
                      onClick={() => this.borrarTodo()}
                      size="small"
                      type="link"
                    >
                      Borrar todo
                    </Button>
                  </ShowIf>
                </Box>
              )}
              rightContent={(
                <Box px="16" pb="16" display="inline-block" style={{ float: 'right' }}>
                  <Button
                    style={{ marginRight: '8px' }}
                    onClick={() => this.cancelar()}
                    size="small"
                  >
                    Cancelar
                  </Button>
                  <Button
                    onClick={() => this.aplicar()}
                    size="small"
                    type="primary"
                    disabled={!sePuedeGuardar}
                  >
                    Aplicar
                  </Button>
                </Box>
              )}
            />
          </Box>
        </Box>
      </Spin>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    gridInit,
    gridSetFilterAction,
    gridRequestAction,
  }, dispatch);
}

const mapStateToProps = (state) => {
  const { grideable, auth } = state;
  const { user: { user_info: { tienda_id: tiendaId } } } = auth;
  return {
    grideableBonificaciones: obtenerEstadoRequestDesdeSaga(grideable, ENDPOINT),
    tiendaId,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true },
)(DescuentosTabs);

DescuentosTabs.propTypes = {
  detalle: detalleCreacionType.isRequired,
  encargo: encargoCreacionType.isRequired,
  gridInit: PropTypes.func.isRequired,
  gridRequestAction: PropTypes.func.isRequired,
  gridSetFilterAction: PropTypes.func.isRequired,
  grideableBonificaciones: PropTypes.shape({
    datos: PropTypes.array,
    success: PropTypes.bool,
    running: PropTypes.bool,
  }),
  onAplicar: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

DescuentosTabs.defaultProps = {
  grideableBonificaciones: {
    datos: [],
    success: null,
    running: false,
  },
};
